import { useQuery } from '@tanstack/react-query'
import { fetchStoreTags } from '../queries/storeTags.queries'

export const STORE_TAGS_KEY = 'storeTags'

export const useStoreTags = () =>
  useQuery({
    queryKey: [STORE_TAGS_KEY],
    queryFn: fetchStoreTags,
    staleTime: 60_000,
  })
